gx-grid-chameleon {
  display: contents;
}
